export default "/static/65d1d7f14fe656b8.png"